"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flightClassName = exports.FlightClassB = exports.FlightClassC = exports.FlightClassP = exports.FlightClassY = void 0;
exports.FlightClassY = 'Y';
exports.FlightClassP = 'P';
exports.FlightClassC = 'C';
exports.FlightClassB = 'B';
// tslint:disable-next-line:cyclomatic-complexity
function flightClassName(flightClass) {
    switch (flightClass) {
        case exports.FlightClassY:
            return 'Economy';
        case exports.FlightClassP:
            return 'Premium Economy';
        case exports.FlightClassC:
            return 'Economy Class';
        case exports.FlightClassB:
            return 'Business';
        default:
            return flightClass;
    }
}
exports.flightClassName = flightClassName;
//# sourceMappingURL=flight_class.js.map